import React from "react";
import { Switch, Route } from "react-router-dom";
import TournamentsView from "../Tournaments/TournamentsView";

const Scrims: React.FC<{ url: string }> = ({ url }) => (
  <Switch>
    <Route
      path={`${url}/`}
      exact
      render={() => <TournamentsView type="upcoming" mode="scrim" />}
    />
  </Switch>
);

export default Scrims;
